import React from 'react'

import { MonitoringsTaskStatusTagRender } from '@app/components/renderers'
import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'

import { CustomEllipsis } from '@app/constants/customEllipsis'

import { columnTitleMap } from '../configs'

import type { Column } from '@app/components/base/Table/types'
import type { MonitoringRegistryDataSource } from '@app/pages/MonitoringRegistryPage/types'

const getOptions = (): Array<Column<MonitoringRegistryDataSource>> => {
  const columnsKeys = Object.keys(columnTitleMap).filter(key => !['status'].includes(key)) as Array<
  keyof MonitoringRegistryDataSource
  >

  return columnsKeys.map(key => {
    return {
      customEllipsis: CustomEllipsis,
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }
  })
}

export const getColumns = (): Array<Column<MonitoringRegistryDataSource>> => {
  return getColumnsFromMap<MonitoringRegistryDataSource>({
    columnTitleMap,
    options: [
      ...getOptions(),
      {
        key: 'status',
        sorter: (a, b) => sorterDispatcher(a.status, b.status),
        render: (_, { status }) => <MonitoringsTaskStatusTagRender status={ status } />
      }
    ]
  })
}
